import { CardMedia, Link, Typography } from "@material-ui/core";

import icon from "../../../../assets/icons/error.svg";
import { Heading } from "../../../../components/Heading";
import {
  useHideFooter,
  usePreventRefresh,
  useShouldRedirectToHomepage,
} from "../../../../hooks";
import { GenericScreen } from "../../../GenericScreen";
import { selectIsFormValidated } from "../../../Welcome/welcome.selectors";

import styles from "./ContactUs.module.scss";

export const ContactUs = (): JSX.Element => {
  useShouldRedirectToHomepage(selectIsFormValidated);
  useHideFooter();
  usePreventRefresh();

  return (
    <GenericScreen>
      <CardMedia component="img" src={icon} className={styles.icon} />
      <Heading
        align="center"
        color="secondary"
        component="h1"
        variant="h2"
        spacingBottom={{ xs: 4, sm: 6 }}
      >
        Skontaktuj się
      </Heading>
      <Typography paragraph align="center">
        email:{" "}
        <Link className={styles.link} href="mailto:odszkodowania@fams.pl">
          odszkodowania@fams.pl
        </Link>
        <br />
        telefon:
        <Link className={styles.link} href="tel:+48223351766">
          +48 22 335 17 66
        </Link>
        <br />
        strona internetowa:{" "}
        <Link
          className={styles.link}
          href="https://www.fams.pl"
          target="_blank"
        >
          www.fams.pl
        </Link>
      </Typography>
      <Typography paragraph align="center">
        <strong>Dane kontaktowe</strong>
        <br />
        Fleet Accident Management Services Sp. z o.o
        <br />
        ul. Postępu 14 B<br />
        New City 3<br />
        02-676 Warszawa
        <br />
        Polska
      </Typography>
    </GenericScreen>
  );
};
